import * as THREE from 'three';
import { jsondan } from '../../FikoThreeType';
import { FikoGrup } from '../FikoGrup';
import { FikoSahne } from '../FikoSahne';
import { FikoTakim } from './FikoTakim';
import { FikoTakimFrezeleme } from './FikoTakimFrezeleme';
import { FikoVektorTakimYol3D } from './FikoVektorTakimYol3d';

export class FikoTakimYolu extends FikoGrup {
    override type: any = "FikoTakimYolu";
    /** */
    sayac = 1;
    /** */
    parametreler = [{
        ismi: "Pozisyon",
        turu: "cubuk",
        min: 0,
        maks: 1,
        adim: 1,
        degeri: 0,
        degisti: () => { },
    }
    ]

    /** */
    sagButonlar: any[] = [
        {
            isim: "Similasyon Yap",
            simge: "play",
            tiklandi: () => {
                import('../fiko-similasyon-v1/fiko-similasyon-v1.component').then(m => {
                    const gosterim = this.sahne?.anaGosterim ?? (this as any).parent?.sahne?.anaGosterim;
                    if (!gosterim?.DialogFiko) { console.warn('DialogFiko bulunamadi'); return; }
                    gosterim.DialogFiko.ac({
                        bilesen: m.FikoSimilasyonV1Component,
                        parametreler: { anaNesne: this },
                        ayarlar: { baslik: 'Similasyon', simgeResim: './simgeler/takimyolu.webp' }
                    });
                });
            }
        }
    ]
    /** */
    sagMenu: any[] = [
        {
            simge: null,
            baslik: "Düzenle",
            tiklandi: () => {
                // this.sahne.anaGosterim.DialogFikoApt.ac(this as any);
            }
        },
        {
            simge: null,
            baslik: "Sil",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);

                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]
    /** */
    aracCubugu: any[] = [
        {
            simge: "edit",
            baslik: "Düzenle",
            tiklandi: () => {

            }
        },
        {
            simge: "trash alternate",
            baslik: "Sil",
            renkSinif: "red",
            tiklandi: () => {
                while (this.children.length) {
                    this.remove(this.children[0]);
                }

                this.parent.remove(this);
                this.sahne.anaGosterim.aktifItem = null;
                this.sahne.anaGosterim.FikoYT.degisti.emit();
                this.sahne.anaGosterim.ciz();
            }
        }
    ]
    /** */
    json: any;
    // similasyonCizgisi = new THREE.Line(new THREE.BufferGeometry(), new THREE.LineBasicMaterial({ color: 0xffffff, vertexColors: true }));

    public override get liste(): any[] {
        return this.children;
    }
    /** */

    private _noktalar: FikoVektorTakimYol3D[];
    public get noktalar(): FikoVektorTakimYol3D[] {
        return this._noktalar;
    }
    public set noktalar(v: FikoVektorTakimYol3D[]) {
        this._noktalar = v;

        // let vertices = [];
        // let colors1 = [];
        // const color = new THREE.Color();

        // for (let i = 0; i < v.length; i++) {

        //     const point = v[i];

        //     vertices.push(point.x, point.y, point.z);

        //     colors1.push(point?.renk?.r, point?.renk?.g, point?.renk?.b);
        // }

        // this.similasyonCizgisi.geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        // this.similasyonCizgisi.geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors1, 3));

        // this.parametreler[0].maks = v.length;
        // this.parametreler[0].degisti = () => { this.takimYoluPozisyonDegisti(this.parametreler[0].degeri) };

        // this.add(this.similasyonCizgisi);
    }


    constructor(public override sahne?: FikoSahne, name?: string) {
        super(sahne);
        this.name = name;

        this.userData['FikoArayuz'].agactaGorunur = true;
        this.userData['FikoArayuz'].listeGoster = false;
        this.userData['FikoArayuz'].simge = "./simgeler/takimyolu.webp";
        // this.similasyonCizgisi.frustumCulled = false;
        // this.similasyonCizgisi.name = "Fiko Similasyon Çizgisi";
    }


    takimYoluPozisyonDegisti(pos: number) {
        // this.similasyonCizgisi.geometry.setDrawRange(0, pos + 1);
    }

    /** Int encoding carpani */
    private static readonly INT_SCALE = 100000;

    async jsonParcala() {
        if (!this.json?.noktalar) return;

        const S = FikoTakimYolu.INT_SCALE;

        // Delta decoding: alanlar sadece degistiginde JSON'da bulunur
        // Eksik alanlar onceki degerden devam eder
        let sonTakim: FikoTakimFrezeleme = null;
        let sonEkBilgi: any = null;
        let sonTakimYonu: number[] = [0, 0, 100000]; // int format default
        let sonHiz: number = 0;
        let sonDevir: number = 0;
        let sonTip: 'rapid' | 'linear' | 'cut' | 'feed' | 'arc_cw' | 'arc_ccw' | 'arc' | 'dwell' | 'tap' | 'tap_retract' = 'linear';
        let sonGuncelSure: number = 0;
        let sonToplamSure: number = 0;
        let sonRenk: THREE.Color = new THREE.Color(1, 1, 1);

        for (let i = 0; i < this.json.noktalar.length; i++) {
            const element = this.json.noktalar[i];

            // Koordinatlar: int mi float mi kontrol (eski format uyumlulugu)
            const isInt = Number.isInteger(element.x) && Math.abs(element.x) > 1000;
            const x = isInt ? element.x / S : element.x;
            const y = isInt ? element.y / S : element.y;
            const z = isInt ? element.z / S : element.z;

            const nokta = new FikoVektorTakimYol3D(x, y, z);

            // Delta decode: alan varsa guncelle, yoksa onceki degeri kullan
            if (element.takim !== undefined) {
                if (element.takim) {
                    // Takim boyutlari int mi kontrol
                    const capInt = Number.isInteger(element.takim.cap) && element.takim.cap > 100;
                    const cap = capInt ? element.takim.cap / S : element.takim.cap;
                    const radius = capInt ? element.takim.radius / S : element.takim.radius;
                    const boy = capInt ? element.takim.boy / 100 : element.takim.boy;
                    const kesmeBoy = capInt ? element.takim.kesmeBoy / 100 : element.takim.kesmeBoy;
                    sonTakim = new FikoTakimFrezeleme(this.sahne, cap, radius, boy, kesmeBoy);
                } else {
                    sonTakim = null;
                }
            }

            if (element.ekBilgiler !== undefined) {
                sonEkBilgi = element.ekBilgiler
                    ? { ismi: element.ekBilgiler.ismi, programIsmi: element.ekBilgiler.programIsmi }
                    : null;
            }

            // TakimYonu: yeni format 'ty' (int array) veya eski format 'takimYonu' (float array)
            if (element.ty !== undefined) {
                sonTakimYonu = element.ty;
            } else if (element.takimYonu !== undefined) {
                sonTakimYonu = element.takimYonu;
            }

            // Renk: yeni format 'r' (hex string) veya eski format 'renk' (float array)
            if (element.r !== undefined) {
                sonRenk = new THREE.Color(element.r);
            } else if (element.renk !== undefined) {
                sonRenk = new THREE.Color().fromArray(element.renk);
            }

            if (element.hiz !== undefined) sonHiz = element.hiz;
            if (element.devir !== undefined) sonDevir = element.devir;
            if (element.tip !== undefined) sonTip = element.tip as typeof sonTip;

            // Sure int mi (x100)
            if (element.guncelSure !== undefined) {
                const sureInt = Number.isInteger(element.guncelSure) && element.guncelSure > 100;
                sonGuncelSure = sureInt ? element.guncelSure / 100 : element.guncelSure;
            }
            if (element.toplamSure !== undefined) {
                const sureInt = Number.isInteger(element.toplamSure) && element.toplamSure > 100;
                sonToplamSure = sureInt ? element.toplamSure / 100 : element.toplamSure;
            }

            nokta.takim = sonTakim;
            nokta.ekBilgiler = sonEkBilgi;

            // TakimYonu int mi float mi
            const tyInt = Number.isInteger(sonTakimYonu[0]) && Math.abs(sonTakimYonu[0]) > 100;
            nokta.takimYonu.set(
                tyInt ? sonTakimYonu[0] / S : sonTakimYonu[0],
                tyInt ? sonTakimYonu[1] / S : sonTakimYonu[1],
                tyInt ? sonTakimYonu[2] / S : sonTakimYonu[2]
            );

            nokta.hiz = sonHiz;
            nokta.devir = sonDevir;
            nokta.renk = sonRenk.clone();
            nokta.guncelSure = sonGuncelSure;
            nokta.toplamSure = sonToplamSure;
            nokta.tip = sonTip;

            // Arc parametreleri int mi
            const arcInt = Number.isInteger(element.i) && Math.abs(element.i || 0) > 100;
            nokta.i = arcInt ? (element.i || 0) / S : (element.i || 0);
            nokta.j = arcInt ? (element.j || 0) / S : (element.j || 0);
            nokta.k = arcInt ? (element.k || 0) / S : (element.k || 0);

            this.noktalar.push(nokta)
        }

        this.json = undefined;
    }


    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        const _rslt: any = { type: this.type, isim: this.name, uuid: this.uuid };

        _rslt.children = [];
        for (let i = 0; i < this.children.length; i++) {
            _rslt.children.push(this.children[i].toJSON());
        }

        // Delta encoding: tekrarlanan alanlar sadece degistiginde yazilir
        _rslt.noktalar = [];
        let sonTakimUuid: string = null;
        let sonEkBilgiIsmi: string = null;
        let sonEkBilgiProgram: string = null;
        let sonHiz: number = null;
        let sonDevir: number = null;
        let sonTip: string = null;
        let sonToplamSure: number = null;
        let sonRenk: string = null;
        // TakimYonu delta: [tx, ty, tz] int array
        let sonTy: string = null;

        for (let i = 0; i < this.noktalar.length; i++) {
            const n = this.noktalar[i];
            const fullJson = n.toJSON();
            const delta: any = {
                x: fullJson.x,
                y: fullJson.y,
                z: fullJson.z,
            };

            // Sadece degisen alanlari yaz
            const takimUuid = n.takim?.uuid ?? null;
            if (takimUuid !== sonTakimUuid) {
                delta.takim = fullJson.takim;
                sonTakimUuid = takimUuid;
            }

            const ekIsmi = n.ekBilgiler?.ismi ?? null;
            const ekProgram = n.ekBilgiler?.programIsmi ?? null;
            if (ekIsmi !== sonEkBilgiIsmi || ekProgram !== sonEkBilgiProgram) {
                delta.ekBilgiler = fullJson.ekBilgiler;
                sonEkBilgiIsmi = ekIsmi;
                sonEkBilgiProgram = ekProgram;
            }

            if (n.hiz !== sonHiz) { delta.hiz = fullJson.hiz; sonHiz = n.hiz; }
            if (n.devir !== sonDevir) { delta.devir = fullJson.devir; sonDevir = n.devir; }
            if (n.tip !== sonTip) { delta.tip = fullJson.tip; sonTip = n.tip; }
            if (n.toplamSure !== sonToplamSure) { delta.toplamSure = fullJson.toplamSure; sonToplamSure = n.toplamSure; }

            // TakimYonu delta encoding - sadece degistiginde yaz
            const tyKey = fullJson.ty ? fullJson.ty.join(',') : null;
            if (tyKey !== sonTy) {
                delta.ty = fullJson.ty;
                sonTy = tyKey;
            }

            // Renk delta encoding - sadece degistiginde yaz
            const renkKey = fullJson.r;
            if (renkKey !== sonRenk) {
                delta.r = fullJson.r;
                sonRenk = renkKey;
            }

            // guncelSure her zaman (animasyon icin gerekli)
            delta.guncelSure = fullJson.guncelSure;

            // Arc parametreleri sadece sifir degilse
            if (n.i) delta.i = fullJson.i;
            if (n.j) delta.j = fullJson.j;
            if (n.k) delta.k = fullJson.k;

            _rslt.noktalar.push(delta);
        }

        return _rslt;
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        // return new FikoTakimYolu(sahne, json.isim);

        const _rslt = new FikoTakimYolu(sahne, json.isim);
        _rslt.uuid = json.uuid;

        _rslt.parent = parent;

        _rslt.json = json;

        _rslt.noktalar = [];
        _rslt.jsonParcala();

        return _rslt;
    }


}